/**************************************************************************************************
 *
 *  This is the main container for all project report views: 
 *
 *  This views are individual components that will fit into the detail-container parent element
 *  defined in this container.
 *
**************************************************************************************************/

import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import dataModel from '../../../models/DataModel';
import ProjectReportTable from './ProjectReportTable';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import ReportHeader from '../ReportHeader';
import ReportFilter from '../ReportFilter';
import ProjectReportFilters from './ProjectReportFilters';
import ProjectReportCollection from '../../../dao/collections/ProjectReportCollection';
import Home from '../../Home/index.js';
import apiFilters from '../../../helpers/apiFilterConstants.js';
import Metadata from '../../../helpers/metadata/Metadata';
import anime from 'animejs';

import './ProjectReport.scss';

const projectDescriptor = {
  project: {
    location: {},
    project_type: {},
    project_manager: {},
    additionalFields: ['completion_steps_count', 'completion_steps_completed_count', 'tasks_count', 'tasks_completed_count'],
  },
};

export class ProjectReport extends BaseComponent {

  constructor(props) {
    super(props);

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.state = {
      displayPopUp: null,
      fileName: null,
      isFilterApplying: false,
    };
    
    this.fetchProjects = this.fetchProjects.bind(this);
    this.createProjectDownloadLink = this.createProjectDownloadLink.bind(this);
    this.animator = new animator();
    this.handleDownloadLocation = this.handleDownloadLocation.bind(this);
    this.changeFileName = this.changeFileName.bind(this);
    this.handleClosePopup = this.handleClosePopup.bind(this);
  }

  componentDidMount() {
    dataModel.inProgress = 20000;
    if (this.props.currentUser && this.props.currentCompany) {
      const perPage = Math.floor((window.innerHeight - 255) / 64) + 3;

      this.projectReportCollection = ProjectReportCollection.build(perPage, {}, this.props.currentUser.id,
        this.props.currentCompany.id, projectDescriptor, this.props.currentUer && this.props.currentUser.isVendorUser);
    
      let collectionFilter = null;
      if  (this.props.goToFilteredState) {
        collectionFilter =  this.props.goToFilteredState;
        if (!collectionFilter.sortField) {
          collectionFilter.sortField = 'project_name';
          collectionFilter.ascending = true;
        }
      } else {
        collectionFilter = this.projectReportCollection.getFilter();
        if (!collectionFilter) {
          collectionFilter = {};
          collectionFilter.sortField = 'project_name';
          collectionFilter.ascending = true;
        }
      }
      this.projectReportCollection.setFilter(collectionFilter);
  
      this.setState({
        view: null,
        projects: this.projectReportCollection.projects || [],
        filterHeight: 0,
        showArchived: collectionFilter.showArchived || false,
        filterDisplayed: collectionFilter.filterDisplayed || false,
        filterActive: this.isFilterActive(collectionFilter),
      });
      if (collectionFilter.filterDisplayed) {
        this.handleFilterActive(true);
      }
      this.fetchProjects(true);
    }
  }

    //to filenamepopup
  changeFileName(value) {
      // let exportLink = this.createProjectDownloadLink()
    this.setState({ fileName: value }, () =>  this.handleApplyFilter(this.projectReportCollection.getFilter()));
  }
  
  handleDownloadLocation() {
      
    this.setState({ displayPopUp: true });
    return; 
  }
  
  handleClosePopup() {
    this.setState({ displayPopUp: false });
  }
    //end

  componentWillUnmount() {
    if (this.usersDataSource) {
      this.usersDataSource.release();
      this.usersDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.currentCompany != this.props.currentCompany && this.props.currentCompany) ||
        (prevProps.currentUser != this.props.currentUser && this.props.currentUser)) {
      this.fetchProjects(true);
    }
  }

  async fetchProjects(initial) {
    if ((!this.state.company && this.props.currentCompany) || (this.state.company && this.state.company.id != this.props.currentCompany.id)) {
      const company = await dataModel.companiesDAO.getCompany(this.props.currentCompany.id, { store: true, recordDescriptor: { company: { additionalFields: ['logo'] } } });
      this.setState({ company: company });
    }
    if (this.projectReportCollection && !(initial && this.state.projects && this.state.projects.length)) {
      this.projectReportCollection.fetchCurrent().then(collectionData => {
        dataModel.inProgress = 0;
        let exportLink = this.createProjectDownloadLink();

        this.setState({ projects: collectionData.projects, totalProjects: collectionData.meta.total_projects, exportLink });
      });
    }
  }

  handleSetProjectFilter(filter) {
    if (this.projectReportCollection) {
      this.animateIn = true;
      this.firstTime = false;

      if (filter) {
        this.analyticsLogger.logManagerDashboardEvent('ProjectReportingFiltered');
      }
      this.projectReportCollection.setFilter({ ...filter });
      this.projectReportCollection.fetchCurrent().then(collectionData => {
        if (collectionData) {
          let exportLink = this.createProjectDownloadLink();
          this.setState({ projects: collectionData.projects, totalProjects: collectionData.meta.total_projects, currentFilter: filter, exportLink, isFilterApplying: false });
        }
      });
    }
  }

  handleSetProjectSortField(fieldName, ascending) {
    if (this.projectReportCollection) {
      const collectionFilter = this.projectReportCollection.getFilter();
      collectionFilter.sortField = fieldName;
      collectionFilter.ascending = ascending;
      this.projectReportCollection.setFilter(collectionFilter);

      this.projectReportCollection.fetchCurrent().then(collectionData => {
        if (collectionData) {
          this.setState({ projects: collectionData.projects, totalProjects: collectionData.meta.total_projects });
        }
      });
    }
  }

  handleProjectNextPage() {
    return this.projectReportCollection.fetchNext().then(collectionData => {
      if (collectionData) {
        this.setState({ projects: collectionData.projects, totalProjects: collectionData.meta.total_projects });
      }
      return collectionData;
    });
  }

  animateIn(viewId) {
    setTimeout(() => {
      let ani = this.animator.createPropertyAnimation(viewId, 200, { left: { startVal: window.innerWidth - 250, endVal: 0 } });
      this.animator.addAnimation(ani);
      this.animator.processAnimationQueue();
    }, 10);
  }

  animateOut(viewId, callback) {
    setTimeout(() => {
      let ani = this.animator.createPropertyAnimation(viewId, 200, { left: { startVal: 0, endVal: window.innwerWidth } });
      this.animator.addAnimation(ani);
      this.animator.processAnimationQueue(callback);
    });
  }

  queryChangeView(viewName, project, build, task, breadCrumbList, forceRecreated) {
    const message = this.textMap.queryDataChanged;
    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.no.toUpperCase(),
      okButtonText: this.textMap.yes.toUpperCase(),
      width: 300,
      height: 180,
      handleOwnerOk: () => {
        this.props.dataModel.systemPopup = null;
        this.props.dataModel.dataChanged = false;
        let recreate = viewName == 'projectHierarchy' && (!this.lastHierarchyProject || !project ||
          project.id != this.lastHierarchyProject.id || forceRecreated);
        this.setState({
          viewName: viewName, selectedProject: project, selectedBuild: build ? build : this.state.selectedBuild, selectedTask: task,
          createNewHierarchyView: recreate, breadCrumbList: breadCrumbList,
        });
      },
    });
  }

  handleSelectProject(project) {
    // TODO: can we user router instead of navigateUri here?
    if (this.props.permissions && this.props.permissions.canEditProject) {
      this.props.dataModel.navigateUri = {
        pathname: '/projects/' + project.id,
        state: { projectName: project.name },
      };
    } 
    else {
      this.props.dataModel.navigateUri = '/tasks/project/' + project.id;
    }
  }

  handleApplyFilter(filter){
    if (this.isFilterActive(filter)) {
      this.handleSetProjectFilter(filter);
      this.setState({ filterActive: true });
    }
    else if (filter.filterDisplayed) {
      this.handleSetProjectFilter(filter);
      //if it got here, that means that no filters were set
      this.setState({ filterActive: false });
    }
    else {
      this.handleSetProjectFilter(filter);
      this.setState({ filterActive: false });
    }
  }

  isFilterActive(filter) {
    return (filter && ((filter.statuses && filter.statuses.length > 0) || (filter.project_types && filter.project_types.length > 0) || (filter.project_managers && filter.project_managers.length > 0) || filter.showArchived || filter.projectEventType));
  }

  handleSearchChange(searchString) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    this.searchTimer = setTimeout(async () => {
      await this.handleSetProjectSearchString(searchString);
      let exportLink = this.createProjectDownloadLink();
      this.setState({ exportLink });
    }, 400);
  }

  handleLogExport() {
    const { filter } = this.projectReportCollection;
    const filtered = filter && Object.keys(filter).length;
    const filteredStatus = filtered ? 'filtered' : 'unfiltered';
    const body = `${this.props.currentUser.name} downloaded the ${filteredStatus} Project Report as a .csv file`;
    Metadata.logEventHistory('Report Download', 'Project Reporting', body);
    this.analyticsLogger.logManagerDashboardEvent('ProjectReportingExport');
  }

  handleSetProjectSearchString(searchString) {
    if (this.projectReportCollection) {
      const collectionFilter = this.projectReportCollection.getFilter();
      collectionFilter.searchString = searchString;
      this.projectReportCollection.setFilter(collectionFilter);
      this.projectReportCollection.fetchCurrent().then(collectionData => {
        if (collectionData) {
          this.setState({ projects: collectionData.projects, totalProjects: collectionData.meta.total_projects });
        }
      });
    }
  }

  createProjectDownloadLink() {
    let collectionFilter = this.projectReportCollection.getFilter();
    if (!collectionFilter) {
      collectionFilter = {};
    }
    
    const searchString = collectionFilter.searchString || '';
    const projectTypes = collectionFilter.project_types ? collectionFilter.project_types.map(pt => { return (pt.id);}).join(',') : '';
    const projectManagers = collectionFilter.project_managers ? collectionFilter.project_managers.map(pm => { return pm.id ? pm.id : pm; }).join(',') : '';
    const state = collectionFilter.state || '';
    const locationID = collectionFilter.locationId || '';
    const user_id = null;

    const status = collectionFilter.statuses ? collectionFilter.statuses.join(',') : '';
    const sortField = collectionFilter.fieldName;
    const ascending = collectionFilter.ascending;

    const pathname = process.env.REACT_APP_API + '/projects/export_project_reports';
    let search = ( 
      '?current_company=' 
      + localStorage.current_company_id 
      + (searchString ? '&keywords=' + searchString : '')
      + (projectTypes ? '&project_types=' + projectTypes: '')
      + (projectManagers ? '&project_managers=' + projectManagers: '')
      + (state ? '&state=' + state : '') 
      + (locationID ?  '&location=' + locationID : '') 
      + (status ? '&status=' + status: '') 
      + (user_id ? '&user=' + user_id : '')
    );
    
    if (sortField) {
      search += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }

    if (collectionFilter.showArchived) {
      search += '&include_archived=true';
    }

    if (collectionFilter.projectEventType && (collectionFilter.startDate || collectionFilter.endDate)) {
      let sDate = new Date(collectionFilter.startDate).toUTCString();
      let eDate = new Date(collectionFilter.endDate).toUTCString();

      let utcStart = Date.parse(sDate);
      let utcEnd = Date.parse(eDate);
      utcEnd += 24 * 60 * 60 * 1000 - 1;

      let offset = (new Date().getTimezoneOffset() * 60 * 1000);

      utcStart += offset;
      utcEnd += offset;

      search += collectionFilter.startDate ? `&start_date=${Math.floor(utcStart / 1000)}` : '';
      search += collectionFilter.endDate ? `&end_date=${Math.floor(utcEnd / 1000)}` : '';

      search += '&date_column=' + (collectionFilter.projectEventType == 'completed' ? 'completed_at' : 'created_at');
    }
    
    if (locationID) {
      search += '&filtering=' + apiFilters.projectFilters.projectCollectionDeep.encodedFilter;
    }
    else {
      search += '&filtering=' + apiFilters.projectFilters.projectCollectionShallow.encodedFilter;
    }
    search += `&filename=${this.state.fileName}`;
    search += `&token=${localStorage.token}`;
    
    return pathname + search;
  }

  handleFilterChange(filter, showArchived = null) {
    if (showArchived != null) {
      this.setState({ showArchived });
    }
    if (this.projectReportCollection) {
      this.setState({ isFilterApplying: true });
      this.projectReportCollection.setFilter(filter);
      this.handleApplyFilter(this.projectReportCollection.getFilter());
    }
  }

  async handleFilterActive(filterDisplayed) {
    if (!this.filterInProgress) {
      this.filterInProgress = true;
      if (filterDisplayed) {
        await anime({
          targets: '.ReportFilter',
          height: 136,
          easing: 'easeInOutCubic',
          duration: 500,
          begin: () => {
            this.setState({ filterDisplayed: true });
          },
          complete: () => {
            this.filterInProgress = false;
          },
        });
      }
      else {
        await anime({
          targets: '.ReportFilter',
          height: 0,
          easing: 'easeInOutCubic',
          duration: 500,
          complete: () => {
            this.setState({ filterDisplayed: false });
            this.filterInProgress = false;
          },
        });
      }

      if (this.projectReportCollection) {
        let filter = this.projectReportCollection.getFilter();
        filter.filterDisplayed = filterDisplayed;
        this.projectReportCollection.setFilter({ ...filter });
      }
    }

  }
  render() {
    if (!this.projectReportCollection) {
      return null;
    }
    const collectionFilter = this.projectReportCollection.getFilter();

    const projectSearchFilter = (
      <ReportFilter minWidth={1000}>
        <ProjectReportFilters
          handleFilterChange={this.handleFilterChange}
          showArchived={this.state.showArchived}
          selectedFilters={collectionFilter}
        /> 
      </ReportFilter>
    );

    let waitSpinner;
    waitSpinner = (
      this.state.isFilterApplying && <Home type="transparent" />
    );

    return (

      <div className="project-report-container"
        ref={(element) => { this.mainContainer = element; }}>
        {waitSpinner}
        <ReportHeader 
          reportTitle={'Project Reporting'}
          reportCount={this.state.totalProjects}
          exportLink={this.state.exportLink}
          logExport={this.handleLogExport}
          handleFilterActive={this.handleFilterActive}
          handleSearchInput={this.handleSearchChange}
          searchString={collectionFilter.searchString}
          filterActive={this.state.filterActive}
          filterDisplayed={this.state.filterDisplayed}
          minWidth={1000}
          handleDownloadLocation={this.handleDownloadLocation}
          handleClosePopup={this.handleClosePopup}
          displayPopUp={this.state.displayPopUp}
          changeFileName={this.changeFileName}
          filename={'project_reports'}
        />
        <div>
          {projectSearchFilter}
        </div>
        <div className="project-report-body">
          <ProjectReportTable 
            reportProjects={this.state.projects}
            totalProjects={this.state.totalProjects}
            refresh={this.refresh}
            selectProject={this.handleSelectProject} 
            filter={collectionFilter}
            searchString={collectionFilter.searchString}
            sortField={collectionFilter.sortField}
            ascending={collectionFilter.ascending}
            handleSortChange={this.handleSetProjectSortField}
            getMoreProjects={this.handleProjectNextPage}
            />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};
export default connect(mapStateToProps)(ProjectReport);



// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ProjectReport/index.js